export type RentalDuration = 'short' | 'week'

export interface DumpsterSize {
  id: string
  yards: number
  name: string
  shortRate: number
  weekRate: number
  weightLimit: string
  dimensions: string
  bestFor: string
  examples: string[]
  image: string
  popular?: boolean
}

export const RENTAL_OPTIONS: Record<
  RentalDuration,
  { label: string; days: string }
> = {
  short: { label: '1–3 day rental', days: '1–3 days' },
  week: { label: '7-day rental', days: '7 days' },
}

export const DUMPSTERS: DumpsterSize[] = [
  {
    id: '10-yard',
    yards: 10,
    name: '10 Yard',
    shortRate: 299,
    weekRate: 349,
    weightLimit: '1 ton',
    dimensions: "12' L × 8' W × 3.5' H",
    bestFor: 'Small cleanouts, garage or attic projects, and light remodeling.',
    examples: [
      'Garage or attic cleanout',
      'Small remodeling work',
      'Yard debris',
    ],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/823a0414-2859-44ef-baec-5c9e3d3a9b43.jpg',
  },
  {
    id: '15-yard',
    yards: 15,
    name: '15 Yard',
    shortRate: 349,
    weekRate: 399,
    weightLimit: '1.5 tons',
    dimensions: "16' L × 8' W × 4' H",
    bestFor:
      'Medium cleanouts, kitchen or bath renovations, and roofing debris.',
    examples: ['Kitchen or bath remodel', 'Medium cleanout', 'Roofing debris'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/57f176d4-b301-4e1f-a21c-b32a41e67058.jpg',
  },
  {
    id: '20-yard',
    yards: 20,
    name: '20 Yard',
    shortRate: 429,
    weekRate: 479,
    weightLimit: '2 tons',
    dimensions: "22' L × 8' W × 4.5' H",
    bestFor: 'Large cleanouts, renovation work, and construction projects.',
    examples: ['Large cleanout', 'Renovation debris', 'Construction projects'],
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/4ead9ca0-fd54-49cd-be18-b81d7bf5c189.jpg',
    popular: true,
  },
]

export function getDumpster(id: string | null): DumpsterSize | undefined {
  return DUMPSTERS.find((d) => d.id === id)
}

export function getRentalPrice(
  dumpster: DumpsterSize,
  duration: RentalDuration,
): number {
  return duration === 'short' ? dumpster.shortRate : dumpster.weekRate
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  }).format(amount)
}
